const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const integerFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0
});

export function formatCurrency(value: unknown): string {
  const amount = Number(value);
  return currencyFormatter.format(Number.isFinite(amount) ? amount : 0);
}

export function formatMileage(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  const mileage = Number(value);
  return Number.isFinite(mileage) ? integerFormatter.format(mileage) : "—";
}

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  }).format(date);
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const datePart = new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  }).format(date);
  const timePart = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  }).format(date);
  return `${datePart} ${timePart}`;
}

export function normalizeVinInput(value: string): string {
  return value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, "").slice(0, 17);
}

export function capitalizeNameInput(value: string): string {
  return value.replace(/(^|[\s'-])([a-z])/g, (_, prefix: string, letter: string) => `${prefix}${letter.toUpperCase()}`);
}

export function formatPhoneInput(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  const hasCountryCode = digits.length === 11 && digits.startsWith("1");
  const local = (hasCountryCode ? digits.slice(1) : digits).slice(0, 10);
  if (!local) return "";
  if (local.length < 4) return `(${local}`;
  if (local.length < 7) return `(${local.slice(0, 3)}) ${local.slice(3)}`;
  const formatted = `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  return hasCountryCode ? `+1 ${formatted}` : formatted;
}

export function formatPhone(value: string | null | undefined): string {
  return value ? formatPhoneInput(value) : "—";
}

export function isPhoneSearchTerm(value: string): boolean {
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, "");
  return /^[+\d\s().-]+$/.test(trimmed) && digits.length >= 7 && digits.length <= 11;
}

export function formatGroupedInput(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const [whole = "", decimal] = String(value).replaceAll(",", "").split(".");
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimal === undefined ? grouped : `${grouped}.${decimal}`;
}

export function parseGroupedInput(value: string | undefined): number {
  return Number((value ?? "").replaceAll(",", ""));
}
